import { Agreement01Icon } from '@hugeicons/react'

import { Card } from '@/shared/ui/Card'
import { EmptyAlert } from '@/shared/ui/EmptyAlert'

import { useTopLikedPartners } from '../model/topLikedPartners'

/**
 * Participante declarou interesses, mas nada do evento cruzou com eles.
 *
 * O destaque abaixo é deliberadamente rotulado como destaque, nunca como
 * recomendação: chamar de "recomendado para você" algo que não casou com nada
 * queimaria a credibilidade do motor no primeiro uso.
 */
export const HighlightsFallback = ({
  digitalProductId
}: {
  digitalProductId: string | number | null | undefined
}) => {
  const { partners, isLoading } = useTopLikedPartners(digitalProductId)

  return (
    <>
      <EmptyAlert
        title="Ainda não encontramos correspondências"
        subtitle="Nenhum participante, empresa ou conteúdo deste evento declarou os mesmos interesses que você. Assim que alguém declarar, as sugestões aparecem aqui."
      />

      {!isLoading && partners.length > 0 && (
        <section className="mt-6">
          <h2 className="text-lg font-semibold text-foreground">Destaques</h2>
          <p className="mt-0.5 mb-3 text-sm text-gray-700">
            Os parceiros mais curtidos do evento.
          </p>

          <div className="grid gap-3">
            {partners.map(partner => (
              <Card key={partner.id} href={`/parceiros/${partner.slug}`} className="p-4">
                <div className="flex items-center gap-3">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-[0.625rem] bg-brand-surface">
                    {partner.logo?.file?.url ? (
                      <img
                        src={partner.logo.file.url}
                        alt=""
                        className="h-full w-full object-cover"
                      />
                    ) : (
                      <Agreement01Icon size={20} className="text-primary opacity-45" />
                    )}
                  </div>
                  <p className="text-base font-semibold text-foreground">
                    {partner.name}
                  </p>
                </div>
              </Card>
            ))}
          </div>
        </section>
      )}
    </>
  )
}
